import { Controller } from "@hotwired/stimulus";

// Handles facet filtering and modals for search refinement.
// Manages the facet modal dialog and debounced form submission.
export default class extends Controller {
  static targets = ["filtersModal", "checkbox"];

  connect() {
    this.submitTimeout = null;

    // Listen for unified filter panel changes (submitted on close)
    // Clear hidden facet inputs first - filter sheet checkboxes with form="search-form" provide values
    this.handleFilterPanelChanged = () => {
      const form = document.getElementById("search-form");
      if (form) {
        form
          .querySelectorAll('input[type="hidden"][name^="f["]')
          .forEach((el) => el.remove());
      }
      this.submitForm();
    };
    this.element.addEventListener(
      "filter-panel:changed",
      this.handleFilterPanelChanged,
    );

    // Listen for global filters:open event (from header button outside this scope)
    this.handleFiltersOpen = () => this.openFiltersModal();
    document.addEventListener("filters:open", this.handleFiltersOpen);
  }

  // Main filters modal methods
  openFiltersModal() {
    if (this.hasFiltersModalTarget) {
      this.filtersModalTarget.showModal();
    }
  }

  closeFiltersModal() {
    if (this.hasFiltersModalTarget) {
      this.filtersModalTarget.close();
    }
  }

  applyFilters() {
    // Sync modal checkboxes to form before submission
    if (this.hasFiltersModalTarget) {
      const form = document.getElementById("search-form");
      if (form) {
        // Remove all existing facet hidden inputs
        form.querySelectorAll('input[name^="f["]').forEach((el) => el.remove());

        // Add hidden inputs for checked modal checkboxes
        const checkedBoxes = this.filtersModalTarget.querySelectorAll(
          'input[type="checkbox"]:checked',
        );
        checkedBoxes.forEach((checkbox) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = checkbox.name;
          input.value = checkbox.value;
          form.appendChild(input);
        });
      }
    }

    this.closeFiltersModal();
    this.submitForm();
  }

  clearFilters() {
    // Uncheck all filter checkboxes (modal + filter sheets)
    this.element
      .querySelectorAll('input[type="checkbox"][name^="f["]')
      .forEach((checkbox) => {
        checkbox.checked = false;
      });

    // Remove any facet hidden inputs from the form
    const form = document.getElementById("search-form");
    if (form) {
      form.querySelectorAll('input[name^="f["]').forEach((el) => el.remove());
    }

    // Close modal and submit
    this.closeFiltersModal();
    this.submitForm();
  }

  disconnect() {
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
    }
    this.element.removeEventListener(
      "filter-panel:changed",
      this.handleFilterPanelChanged,
    );
    document.removeEventListener("filters:open", this.handleFiltersOpen);
  }

  submitForm() {
    // Debounce form submission
    if (this.submitTimeout) {
      clearTimeout(this.submitTimeout);
    }

    this.submitTimeout = setTimeout(() => {
      const form = document.getElementById("search-form");
      if (!form) return;

      // Reset page and expanded flag — new filter selection is a new search
      const pageField = form.querySelector('[name="page"]');
      if (pageField) pageField.value = 1;
      const expandedField = form.querySelector('[name="expanded"]');
      if (expandedField) {
        expandedField.remove();
        // Turbo Stream responses don't update the URL, so remove it manually
        const url = new URL(window.location);
        url.searchParams.delete("expanded");
        history.replaceState(history.state, "", url);
      }

      form.requestSubmit();
    }, 300);
  }
}
